module.exports = __webpack_public_path__ + "img/sprinkle-2.c687f5bb.webp";